import { mimeTypes } from '@/shared/constants';
import { type DriveFile, type ExportMimeType } from '@/shared/DriveTypes';
import gup from './gup';

export const pdfJSVersion = import.meta.env?.VITE_PDFJS_VERSION as string;
export const isBun = !import.meta.env?.PROD && ('Bun' in globalThis || typeof window === 'undefined');
export const isTest = isBun || import.meta.env?.VITE_PLAYWRIGHT_TEST === 'true';
export const hasWindow = typeof window !== 'undefined';
export const host = hasWindow ? window.location.hostname : '';
export const protocol = hasWindow ? window.location.protocol : '';
const port = hasWindow ? window.location.port : '';
export const siteURL = isBun
  ? 'http://localhost'
  : typeof window === 'undefined'
    ? ''
    : `${protocol}//${host}${port ? `:${port}` : ''}`;

export const apiKey = ['localhost', 'youneedawiki.dev', 'qa.youneedawiki.dev'].includes(host)
  ? 'AIzaSyDcEOk_b_K82NhcmI1CEOpOWMX0VEIULso'
  : 'AIzaSyC23l-4JKofQV5hacePzOv5gY54C_Dapf8';

export const TEST = typeof process !== 'undefined' && process.env.NODE_ENV === 'test' && import.meta.env?.DEV;

export const publicDocsId = '1NqCSiMuEfPfaHTumR_rX6J8zo7ygjx8q';

export const driveScope =
  'openid email profile https://www.googleapis.com/auth/documents https://www.googleapis.com/auth/drive https://www.googleapis.com/auth/contacts.readonly';

export const defaultScope =
  hasWindow && gup('drive')
    ? driveScope
    : 'openid email profile https://www.googleapis.com/auth/documents https://www.googleapis.com/auth/drive.file https://www.googleapis.com/auth/contacts.readonly';

/*
  Note: eslint-plugin-no-compound-dev checks against the name `DEV`
  If you change the name, update the plugin
*/
export const DEV = import.meta.env?.DEV; // Workers doesn't support for import.meta.env
export const PROD = import.meta.env?.PROD;
export const LOCAL = hasWindow && window.location.hostname === 'localhost';

export const LEGACY = !isBun && import.meta.env?.VITE_LEGACY === 'true';
export const MODERN = !LEGACY;
export const baseURL = LEGACY ? (DEV ? 'http://localhost:3000/api' : '/api/v2') : '/api';
export const preview = DEV && gup('preview');

// https://developers.google.com/drive/api/guides/ref-export-formats
export const exportFormats = {
  document: 'text/html',
  spreadsheet: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  presentation: 'text/plain',
  text: 'text/plain',
  docx: 'text/html',
  xlsx: 'text/html',
  pdf: 'text/plain',
  ppt: 'text/plain',
  pptx: 'text/plain',
  html: 'text/html',
  markdown: 'text/markdown',
  markdownX: 'text/markdown',
} satisfies Partial<Record<keyof typeof mimeTypes, ExportMimeType>>;

export const pageExportMimeTypes: DriveFile['mimeType'][] = [
  // documents
  mimeTypes.document,
  mimeTypes.docx,
  mimeTypes.word,

  // sheets
  mimeTypes.spreadsheet,
  mimeTypes.excel,
  mimeTypes.csv,
  mimeTypes.xlsx,

  // text
  mimeTypes.html,
  mimeTypes.markdown,
  mimeTypes.markdownX,
  mimeTypes.text,
  mimeTypes.rtf,
  mimeTypes.text,

  // slides
  mimeTypes.presentation,
  mimeTypes.ppt,
  mimeTypes.pptx,
  mimeTypes.slideshow,
];

export const editURLs = {
  document: 'https://docs.google.com/document/d/',
  spreadsheet: 'https://docs.google.com/spreadsheets/d/',
  presentation: 'https://docs.google.com/presentation/d/',
  drawing: 'https://docs.google.com/drawings/d/',
  form: 'https://docs.google.com/forms/d/',
} satisfies Partial<Record<keyof typeof mimeTypes, string>>;

export const newFileId = 'new-';
export const copyFileId = 'copy';
export const indexName = 'wiki.page';
export const fileScope = DEV ? gup('scope') : false;
export const search = hasWindow ? window.location.search.replace('?login=success', '') : '';

const userAgentData =
  typeof navigator !== 'undefined' && 'userAgentData' in navigator
    ? (navigator.userAgentData as {
        platform: 'macOS';
      })
    : undefined;

const isMacOS = typeof navigator !== 'undefined' && /Mac OS/.test(navigator.userAgent);

// Testing
// export const platform = 'Windows';
export const platform =
  typeof navigator === 'undefined'
    ? ''
    : userAgentData
      ? userAgentData.platform
      : isMacOS
        ? 'macOS'
        : navigator.userAgent.includes('Windows')
          ? 'Windows'
          : navigator.userAgent.includes('Linux')
            ? 'Linux'
            : '';

export const htmlOnly = hasWindow ? gup('html') : false;
export const debug = hasWindow ? gup('debug') : false;
export const cacheFlag = hasWindow ? gup('cache') : false;
export const clearCache = hasWindow ? gup('nocache') : false;
export const expiredToken = DEV && hasWindow ? gup('expired') : false;
export const prefetchDisabled = DEV && hasWindow ? gup('nofetch') : false;
export const focusDisabled = prefetchDisabled;

export const maxDepth = isBun ? 100 : 1000;

export const isIOS = hasWindow && /iPad|iPhone|iPod/.test(navigator.userAgent);

export const rootFolderQuery = `'root' in parents and mimeType = 'application/vnd.google-apps.folder' and name = 'YNAW'`;

export const transitionDuration = {
  enter: isBun ? 0 : 200,
  exit: 0,
};

export const tooltipEnterDelay = {
  enterDelay: isBun ? 0 : 500,
  enterNextDelay: 500,
};

export const expires_in_default = 3599;
export const ms = 1000;
export const maxCopyAmount = 50;
export const transparentGif = `data:image/gif;base64,R0lGODlhAQABAIABAP///wAAACwAAAAAAQABAAACAkQBADs=`;
export const MB = 1048576; // 1024 * 1024
export const path = hasWindow ? window.location.pathname : '';
